import { render, staticRenderFns } from "./proditem.vue?vue&type=template&id=35bf1ef9&scoped=true&"
import script from "./proditem.vue?vue&type=script&lang=js&"
export * from "./proditem.vue?vue&type=script&lang=js&"
import style0 from "./proditem.vue?vue&type=style&index=0&id=35bf1ef9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf1ef9",
  null
  
)

export default component.exports